import { render, staticRenderFns } from "./StartSideNeedsCompleteProfile.vue?vue&type=template&id=a778dcc4"
import script from "./StartSideNeedsCompleteProfile.vue?vue&type=script&lang=js"
export * from "./StartSideNeedsCompleteProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports